export const ACCESS_MESSAGES = Object.freeze({
  NEED_LOGIN: '로그인 후 이용해 주세요',
  NEED_UPGRADE: '등업 완료 후 이용 가능해요',
});
